import { useQueryClient } from '@tanstack/react-query';

import { RQ_X_COUNTRY_CODE } from '@/modules/ReactQuery/cacheKeys';

export function useCountryHeader(): string | undefined {
  const queryClient = useQueryClient();
  const countryCode = queryClient.getQueryData<string>([RQ_X_COUNTRY_CODE]);
  return countryCode;
}
